import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

/* ============================================================
   Destino do redirect OAuth da Revolut: apanha o `code` do URL
   e conclui a autorização no backend.
   ============================================================ */
const RevolutCallback = () => {
    const navigate = useNavigate();
    const [estado, setEstado] = useState('a-autorizar'); // a-autorizar | ok | erro
    const [msg, setMsg] = useState('A concluir a autorização com a Revolut…');

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const erro = params.get('error');
        if (erro) { setEstado('erro'); setMsg(`A Revolut devolveu um erro: ${erro}`); return; }
        if (!code) { setEstado('erro'); setMsg('Não foi recebido nenhum código de autorização no endereço.'); return; }

        api.post('/revolut/autorizar', { code })
            .then(() => { setEstado('ok'); setMsg('Aplicação autorizada com sucesso! Já pode sincronizar as transações.'); })
            .catch(e => { setEstado('erro'); setMsg(e.response?.data?.error || e.message); });
    }, []);

    const cor = estado === 'ok' ? '#166534' : estado === 'erro' ? '#991b1b' : '#334155';
    const fundo = estado === 'ok' ? '#dcfce7' : estado === 'erro' ? '#fee2e2' : '#f1f5f9';

    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f8fafc', padding: 20 }}>
            <div style={{ background: '#fff', borderRadius: 14, padding: 30, maxWidth: 520, width: '100%', boxShadow: '0 10px 40px rgba(0,0,0,0.12)' }}>
                <h2 style={{ marginTop: 0 }}>Integração Revolut Business</h2>
                <div style={{ background: fundo, color: cor, borderRadius: 10, padding: '14px 16px', fontSize: '0.95rem', lineHeight: 1.5 }}>
                    {estado === 'a-autorizar' && '⏳ '}{estado === 'ok' && '✅ '}{estado === 'erro' && '⚠️ '}
                    {msg}
                </div>
                <div style={{ display: 'flex', gap: 8, marginTop: 20, justifyContent: 'flex-end' }}>
                    <button onClick={() => navigate('/despesas')}
                        style={{ padding: '9px 16px', border: '1px solid #3182ce', background: '#3182ce', color: '#fff', borderRadius: 8, cursor: 'pointer' }}>
                        Ir para Despesas
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RevolutCallback;
